import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { resolvePageMeta } from './pageMeta';

/**
 * Breadcrumb della pagina, pensato per stare nella topbar (header-left),
 * allo stesso livello di "Supporto clienti". Deriva le voci da pageMeta.
 */
const SidBreadcrumb = () => {
  const location = useLocation();
  const { crumbs } = resolvePageMeta(location.pathname);

  const userType = sessionStorage.getItem('userType');
  const dashboardHref = userType ? `/${userType}/dashboard` : '/';

  if (!crumbs || crumbs.length === 0) return null;

  return (
    <nav className="sid-breadcrumb" aria-label="breadcrumb">
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1;
        const isFirst = i === 0;
        // Una voce può essere una semplice etichetta oppure { label, to }: in quel
        // caso diventa un link, che è il modo per tornare all'elenco da una scheda.
        const label = typeof crumb === 'string' ? crumb : crumb.label;
        const to = isFirst ? dashboardHref : (typeof crumb === 'string' ? null : crumb.to);
        return (
          <React.Fragment key={i}>
            {to && !isLast ? (
              <Link to={to} className="sid-breadcrumb__item">{label}</Link>
            ) : (
              <span className={`sid-breadcrumb__item${isLast ? ' is-active' : ''}`}>{label}</span>
            )}
            {!isLast && <span className="sid-breadcrumb__sep">&gt;</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default SidBreadcrumb;
